( function( $ ) {

	var slider = {
		init : function() {
			this.globalSlider();
		},
		globalSlider : function() {
			$( '.bxslider' ).bxSlider( {
				touchEnabled: false,
				auto: true,
				pager: ($('.bxslider>li').length > 1) ? true : false,
				controls : true,
				captions: true,
				onSliderLoad: function() {
					$( '.bx-wrapper .bx-caption' ).height( $( '.bx-wrapper' ).height() );
				}
			} );
		}
	};

    $( document ).ready( function() {
		slider.init();
	} );

} )( jQuery );
